import { FormGroup, FormControl, Validators } from "@angular/forms";
import { EmailValidator } from 'src/app/template/customValidators/emailValidator';


export var GipUserRegisterForm = new FormGroup({
    SALUTION: new FormControl('', Validators.required),
    TITLE: new FormControl(),
    NAME: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    SURNAME: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    LOGIN: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    EMAIL: new FormControl('', [EmailValidator, Validators.maxLength(250)]),
    PHONE: new FormControl('', [Validators.required, Validators.maxLength(20)]),
    AcceptTermOfUse: new FormControl(),
    ReadDataProtection: new FormControl(),
  });

export class GiUserRegisterModel {
  SALUTION: string;
  TITLE: string;
  NAME: string;
  SURNAME: string;
  LOGIN: string;
  EMAIL: string;
  PHONE: string;

  fromFormGroupModel(formModel: FormGroup){
    this.SALUTION = formModel.controls["SALUTION"].value;
    this.TITLE = formModel.controls["TITLE"].value;
    this.NAME = formModel.controls["NAME"].value;
    this.SURNAME = formModel.controls["SURNAME"].value;
    this.LOGIN = formModel.controls["LOGIN"].value;
    this.EMAIL = formModel.controls["EMAIL"].value;
    this.PHONE = formModel.controls["PHONE"].value;
  }

  getUpdateModel(recaptcharesponse, LANG) {
    return new Map ([
      ["recaptcharesponse", `'${recaptcharesponse}'`],
      ["LANG", `'${LANG}'`]
    ]);
  }
}


  export var GipUserProcessStatForm = new FormGroup({
    OBJECTID: new FormControl(),
    FULLNAME: new FormControl(),
    LOGIN: new FormControl(),
    TEXT: new FormControl(),

  });